function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      marginTop: 3
    }
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.49 17.021a8.51 8.51 0 1 0-8.446-7.451l-8.417 4.37a8.51 8.51 0 1 0 .084 11.748l8.371 4.186a8.51 8.51 0 1 0 2.487-4.783l-8.598-4.3a8.611 8.611 0 0 0-.014-1.987l8.42-4.372a8.485 8.485 0 0 0 6.112 2.59Z",
    fill: "#fff",
    style: {
      transform: "scale(.42)"
    }
  }));
};

export default SvgShare;